<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <book-simple v-if="obra" :obra="obra" type="full"/>
            </div>
        </div>
    </div>
</template>
<script>
import ObraService from '../services/obra-service'
import OverlayService from '../services/overlay-service'
import AuthService from '../services/auth-service'
import BookSimple from '@/components/BookSimple'

export default {
  components: {
    BookSimple
  },

  watch: {
    $route (to, from) {
      this.bookId = this.$route.params.id
      this.loadObra()
    }
  },

  data () {
    return {
      bookId: undefined,
      obra: undefined
    }
  },

  mounted () {
    this.bookId = this.$route.params.id
    this.loadObra()
  },

  methods: {
    recomendar (obra) {
      const value = !obra.recomendado
      OverlayService.trigger('show', true)

      ObraService.recomendar(obra.id, value)
        .then(() => {
          OverlayService.trigger('show', false)
          obra.recomendado = value
        })
        .catch(er => OverlayService.trigger('show', false))
    },

    loadObra () {
      OverlayService.trigger('show', true)

      ObraService.findOneById(this.bookId)
        .then(response => response.data)
        .then(obra => {
          OverlayService.trigger('show', false)
          this.obra = obra
        })
        .catch(er => OverlayService.trigger('show', false))
    }
  }
}
</script>
